import store from '@/store'

export default {
  showLoader (message, state, show = true) {
    store.commit('showLoader', {
      show,
      message,
      state
    })
  },

  hideLoader () {
    store.commit('hideLoader')
  },

  showMessage (message) {
    store.commit('showMessage', message)
  },

  hideMessage () {
    store.commit('hideMessage')
  }
}



//////////////////
// WEBPACK FOOTER
// ./my_modules/store/modals.js
// module id = null
// module chunks = 